/**
 * Centralized query keys for Item queries
 * 
 * Ensures consistency across all Item-related queries and mutations.
 * Prevents cache key mismatches that cause snap-back issues.
 */

export const itemQueryKeys = {
  /**
   * Query key for a single item detail
   */
  detail: (name: string) => ["item", name] as const,
  
  /**
   * Query key for item list
   */
  list: () => ["items", "list"] as const,
  
  /**
   * Query key for all item queries (for invalidation)
   */
  all: () => ["item"] as const,
};

